import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field-range" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_imdex_text_field, {
      lazy: "",
      small: "",
      value: _ctx.minVal,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minVal) = $event)),
      onKeyup: _withKeys(_ctx.onApply, ["enter"]),
      ref: "min",
      type: "number",
      label: _ctx.$t('ssa.displayPane.min'),
      disabled: _ctx.isFixed
    }, null, 8, ["value", "onKeyup", "label", "disabled"]),
    _createVNode(_component_imdex_text_field, {
      lazy: "",
      small: "",
      value: _ctx.maxVal,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maxVal) = $event)),
      onKeyup: _withKeys(_ctx.onApply, ["enter"]),
      ref: "max",
      type: "number",
      label: _ctx.$t('ssa.displayPane.max'),
      disabled: _ctx.isFixed
    }, null, 8, ["value", "onKeyup", "label", "disabled"]),
    _createVNode(_component_imdex_btn, {
      disabled: _ctx.isFixed,
      onClick: _ctx.onReset,
      mini: "",
      text: "",
      fab: "",
      small: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}